
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/vue';
import ContentChannelItemList from '@/components/ContentChannelItem/ContentChannelItemList.vue';

export default  {
  name: 'Tab2',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, ContentChannelItemList }
}
